import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ForbiddenService {
    private _isForbidden!: boolean;

    private _isForbidden$: Subject<boolean> = new Subject<boolean>();

    isForbidden$: Observable<boolean> = this._isForbidden$.asObservable();

    forbid(): void {
        this._isForbidden$.next(true);
    }

    allow(): void {
        this._isForbidden$.next(false);
    }
}